<div class="card">
  <div class="ui-g ui-fluid">
    <div class="ui-g-12">
      <sf-form id="kv-schema-form" [schema]="mySchema" [(model)]="myModel" (onChange)="getFormValue($event.value)"></sf-form>
      <div style="padding-left: 11px; margin-top: 15px;" *ngIf="!readOnly">
        <button
          pButton
          type="button"
          class="k-generic-btn"
          label="{{ 'common.save' | translate }}"
          (click)="submitForm()">
        </button>
        <button
        pButton
        type="button"
        class="k-generic-btn"
        label="{{ 'common.cancel' | translate }}"
        (click)="closeForm()">
      </button>

      </div>
    </div>
  </div>
</div>




// WEBPACK FOOTER //
// ./src/app/views/administration/apps-config/json-schema-form/kv-json-form-schema.component.html